<template>
  <div>
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-cascader
          placeholder="请选择实验分类"
          :options="experOptions"
          v-model="experarr"
          :props="{
            checkStrictly: true,
            label: 'itemname',
            value: 'itemid',
            children: 'children',
          }"
          clearable
          @change="changeExp"
        ></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-cascader
          placeholder="请选择专业班级"
          :options="orgOptions"
          v-model="orgarr"
          :props="{
            checkStrictly: true,
            label: 'orgname',
            value: 'orgid',
            children: 'children',
          }"
          clearable
          @change="changeOrg"
        ></el-cascader>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          v-model="seldate"
          :clearable="false"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="datechange"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          plain
          :disabled="disabled"
          @click="GetClassExperSumData"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          type="success"
          plain
          :disabled="expdisabled"
          @click="ExportClassExperSumData"
          >导出</el-button
        >
      </el-form-item>
    </el-form>
    <div class="table">
      <el-table
        ref="table"
        border
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        style="width: 100%"
        v-el-table-infinite-scroll="load"
        height="720"
      >
        <el-table-column type="index" width="60"> </el-table-column>
        <el-table-column
          prop="subjectname"
          label="学科名称"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="experimenttypename"
          label="实验分类"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="experimentname"
          label="实验名称"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="specname"
          label="专业"
          width="150"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="classname"
          label="班级"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="operacount"
          label="操作次数"
          width="110"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="mintime"
          label="最低时长"
          width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="maxtime"
          label="最高时长"
          width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="avgtime"
          label="平均时长"
          width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="taskcount"
          label="发布作业数"
          width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="submitcount"
          label="提交作业数"
          width="120"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <el-alert
        v-if="isflag"
        title="正在努力加载中..."
        type="success"
        center
        :closable="false"
        show-icon
      ></el-alert>
      <el-alert
        v-if="isMore"
        title="没有更多啦！"
        type="warning"
        center
        show-icon
      ></el-alert>
    </div>
  </div>
</template>

<script>
import Api from "../../api/index";
export default {
  data() {
    return {
      params: {
        specid: "",
        classid: "",
        subjectid: "",
        experimenttypeid: "",
        experimentid: "",
        startdate: "",
        enddate: "",
      },
      orgOptions: [],
      experOptions: [],
      seldate: [],
      orgarr: [],
      experarr: [],
      allData: [],
      tableData: [],
      count: 0,
      everycount: 100,
      isflag: false,
      isMore: false,
      loading: true,
      disabled: false,
      expdisabled: false,
    };
  },
  created() {
    this.setDate();
    this.GetOrgTree();
    this.GetExpTree();
    this.GetClassExperSumData();
  },
  mounted() {},
  methods: {
    changeOrg() {
      if (this.orgarr && this.orgarr.length == 1) {
        this.params.specid = this.orgarr[0];
        this.params.classid = "";
      } else if (this.orgarr && this.orgarr.length == 2) {
        this.params.specid = this.orgarr[0];
        this.params.classid = this.orgarr[1];
      } else {
        this.params.specid = "";
        this.params.classid = "";
      }
    },
    changeExp() {
      console.log(this.experarr);
      if (this.experarr && this.experarr.length == 1) {
        this.params.subjectid = this.experarr[0];
        this.params.experimenttypeid = "";
        this.params.experimentid = "";
      } else if (this.experarr && this.experarr.length == 2) {
        this.params.subjectid = this.experarr[0];
        this.params.experimenttypeid = this.experarr[1];
        this.params.experimentid = "";
      } else if (this.experarr && this.experarr.length == 3) {
        this.params.subjectid = this.experarr[0];
        this.params.experimenttypeid = this.experarr[1];
        this.params.experimentid = this.experarr[2];
      } else {
        this.params.subjectid = "";
        this.params.experimenttypeid = "";
        this.params.experimentid = "";
      }
    },
    setDate() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.seldate = [start, end];
      this.params.startdate = this.seldate.length > 0 ? this.seldate[0] : "";
      this.params.enddate = this.seldate.length > 1 ? this.seldate[1] : "";
    },
    datechange(e) {
      this.params.startdate = e != null ? e[0] : "";
      this.params.enddate = e != null ? e[1] : "";
    },
    async GetOrgTree() {
      const res = await Api.organization.GetOrgDataTree();
      if (res.success) this.orgOptions = res.rows;
    },
    async GetExpTree() {
      const res = await Api.sum.GetExperTree();
      if (res.success) this.experOptions = res.rows;
    },
    load() {
      this.isMore = false;
      this.isflag = true;
      if (this.isflag) {
        var arr = this.allData.slice(this.count, this.count + this.everycount);
        arr.forEach((a) => this.tableData.push(a));
        this.count += this.everycount;
        this.isflag = false;
      }
    },
    async GetClassExperSumData() {
      this.disabled = true;
      this.loading = true;
      this.tableData = [];
      const res = await Api.sum.GetClassExperSumData(this.params);
      if (res.success) this.allData = res.rows;
      else this.$message.error(res.msg);
      this.count = 0;
      this.load();
      this.loading = false;
      this.disabled = false;
    },
    async ExportClassExperSumData() {
      this.expdisabled = true;
      const res = await Api.sum.ExportClassExperSumData(this.params);
      if (res.success) window.location.href = res.rows;
      this.expdisabled = false;
    },
  },
};
</script>

<style scoped>
</style>
